// extracted by mini-css-extract-plugin
export default {"content":"ConfirmModal_content__Gh-7V","title":"ConfirmModal_title__z1TNa"};